import {
  LocalizationProvider,
  LocalizationProviderProps,
  PickerValidDate
} from '@mui/x-date-pickers'
import { DesktopDatePicker, DesktopDatePickerProps } from '@mui/x-date-pickers'
import { ptBR } from 'date-fns/locale'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import React, { ReactNode } from 'react'

interface DatePickerProviderProps
  extends Omit<LocalizationProviderProps<Date, typeof ptBR>, 'dateAdapter' | 'adapterLocale'> {
  children: ReactNode
}

interface ExtendedDatePickerProps<TDate extends Date> extends DesktopDatePickerProps<TDate> {
  title?: string
}

export const DatePicker = <TDate extends PickerValidDate>({
  value,
  title,
  className,
  ...props
}: ExtendedDatePickerProps<TDate>) => {
  return (
    <div
      title={title || (value instanceof Date ? value.toLocaleDateString('pt-BR') : undefined)}
      className={className}
    >
      <DesktopDatePicker value={value} sx={{ width: '100%' }} {...props} />
    </div>
  )
}

export const DatePickerProvider: React.FC<DatePickerProviderProps> = ({ children, ...props }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR} {...props}>
      {children}
    </LocalizationProvider>
  )
}
